import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Collapse } from 'antd';
import { isNilOrEmpty } from 'utils/helpers';
import { capitalizeName } from 'utils/strings';
import { DetailsDescriptions, DetailsLabel } from './styled';
var Panel = Collapse.Panel;
var DetailItem = function (_a) {
    var label = _a.label, value = _a.value, url = _a.url;
    if (isNilOrEmpty(value))
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(DetailsLabel, { children: label }), isNilOrEmpty(url) ? _jsx("span", { children: value }) : _jsx("a", { href: url, children: value })] }));
};
var RequestDetails = function (_a) {
    var memberId = _a.memberId, memberFirstName = _a.memberFirstName, memberLastName = _a.memberLastName, ticketNumber = _a.ticketNumber, carePlanType = _a.carePlanType, requestType = _a.requestType, location = _a.location, insurance = _a.insurance, preferences = _a.preferences, isDetailsVisible = _a.isDetailsVisible;
    var descriptionItems = [
        { key: 'memberName', label: 'Member Name', value: capitalizeName("".concat(memberFirstName, " ").concat(memberLastName)), url: "members/".concat(memberId) },
        { key: 'linkedTicket', label: 'Linked Ticket', value: ticketNumber, url: "ticket/".concat(ticketNumber) },
        { key: 'carePlanType', label: 'Care Plan Type', value: carePlanType },
        { key: 'requested', label: 'Requested', value: requestType },
        { key: 'location', label: 'Location', value: location },
        { key: 'insurance', label: 'Insurance', value: insurance },
        { key: 'preferences', label: 'Preferences', value: preferences },
    ];
    return (_jsx(Collapse, { activeKey: isDetailsVisible ? '1' : undefined, children: _jsx(Panel, { header: "Request Details", children: _jsx(DetailsDescriptions, { children: descriptionItems.map(function (item) { return (_jsx(DetailItem, { label: item.label, value: item.value, url: item.url }, item.key)); }) }) }, "1") }));
};
export default RequestDetails;
